export const STORE_PERMISSAO = "STORE_PERMISSAO";

export const storePermissao = (permissao) => ({
  type: STORE_PERMISSAO,
  permissao,
});
